export default {"src":"/_next/static/media/arrow-down-white-2.9ec6527f.svg","height":9,"width":14};